import { environment } from '@environments/environment';

export const GET_TESTIMONIES_QUERY = (langcode: string, from: number, size: number) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_temoignages,
  body: {
    from,
    size,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    _source: ['author', 'image', 'text', 'url'],
    sort: [
      {
        weight: {
          order: 'asc',
        },
        created: {
          order: 'desc',
        },
      },
    ],
  },
});
